import {
  handleSettingsAddLocations,
  handleSettingsAddMachines,
  handleSettingsAddSpecificLocations,
  handleSettingsLocationSelect,
  handleSettingsMachineSelect,
  handleSettingsSelectAll,
  handleSettingsSelectedOne,
  handleSettingsSpecificLocationSelect,
} from "features/settings/slice/force&CommandAndAdminSelectSlice";
import {
  selectLocationsHandler,
  selectMachinesHandler,
  selectSpecificLocationsHandler,
  unselectAllMachinesHandler,
} from "shared/hooks/useSelectSwitchesDispatches";
import selectBoxResetHandler from "shared/helpers/ess-tgs-tes-mc/selectBoxResetHandler";
import { settingsSwitchCountHandler } from "./settingsSwitchCountHandler";

export const buttonsHandler = (propsObj,setSelectSearchMethod,isValueSettings) => {
  const {
    button,
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedLocations,
    selectedSpecificLocations,
    selectedMachines,
    swtName,
    dispatch,
    data,
    locations,
    handleClose,
    isSelected,
    isSelectedSys,
    system,
    program,

  } = propsObj;

  const switchName = system ? system : swtName;

  settingsSwitchCountHandler(isMachineSelected, swtName, dispatch);


  if (button === 1) {
    if(isValueSettings){
      setSelectSearchMethod(1);
    }
    if (isAllSelected) {


      dispatch(
        handleSettingsSelectedOne({
          switch: swtName,
          selectedOne: "all",
        })
      );

      selectLocationsHandler(
        locations,
        program,
        data,
        dispatch,
        switchName,
        isSelectedSys
      );
    } else if (isLocationSelected.indexOf(true) !== -1) {

      selectLocationsHandler(
        selectedLocations,
        program,
        data,
        dispatch,
        switchName,
        isSelectedSys
      );


      if (selectedSpecificLocations.length > 0) {
        selectSpecificLocationsHandler(
          selectedSpecificLocations,
          program,
          data,
          dispatch,
          switchName,
          isSelectedSys
        );
      }

      if (selectedMachines.length > 0) {

        selectMachinesHandler(
          selectedMachines,
          program,
          data,
          dispatch,
          switchName,
          isSelectedSys
        );
      }
    } else if (
      isSpecificLocationSelected.some((location) => location.includes(true))
    ) {

      selectSpecificLocationsHandler(
        selectedSpecificLocations,
        program,
        data,
        dispatch,
        switchName,
        isSelectedSys
      );


      if (selectedMachines.length > 0) {
        selectMachinesHandler(
          selectedMachines,
          program,
          data,
          dispatch,
          switchName,
          isSelectedSys
        );
      }
    } else if (selectedMachines.length > 0) {

      selectMachinesHandler(
        selectedMachines,
        program,
        data,
        dispatch,
        switchName,
        isSelectedSys
      );
    } else if (!isSelected) {
      dispatch(
        handleSettingsSelectedOne({
          switch: swtName,
          selectedOne: null,
        })
      );
    }

    handleClose();
  } else {
    if(isValueSettings){
      setSelectSearchMethod(null)
    }
    const { locationList, specificLocationList, machineList } =
      selectBoxResetHandler(data, "setting");
    const resetObj = { switch: swtName, arr: [] };
    const locationResetObj = { switch: swtName, arr: locationList };
    const specificLocationResetObj = {
      arr: specificLocationList,
      switch: swtName,
    };
    const machineResetObj = { switch: swtName, arr: machineList };


    dispatch(handleSettingsSelectAll({ switch: swtName, status: false }));
    dispatch(handleSettingsSelectedOne({ switch: swtName, selectedOne: null }));


    dispatch(handleSettingsAddLocations(resetObj));

    dispatch(handleSettingsAddSpecificLocations(resetObj));

    dispatch(handleSettingsAddMachines(resetObj));


    dispatch(handleSettingsLocationSelect(locationResetObj));

    if (specificLocationList.length > 0) {
      dispatch(handleSettingsSpecificLocationSelect(specificLocationResetObj));
    }

    dispatch(handleSettingsMachineSelect(machineResetObj));

    unselectAllMachinesHandler(
      locations,
      program,
      data,
      dispatch,
      switchName,
      isSelectedSys
    );
  }
};
